export const ENTRY_TYPE_SERVICE = 'SERVICE';
export const ENTRY_TYPE_EXPENSE = 'EXPENSE';
export const ENTRY_TYPE_DRAFT = 'DRAFT';
export const PRIOR = 'prior';
export const AFTER = 'after';
export const RECEIPT_POLLING_INTERVAL_MS = 1500;

export const baseDraft = {
  id: '',
  companyName: '',
  companyShortName: '',
  incidentId: '',
  incidentName: '',
  taskId: '',
  taskNumber: '',
  taskName: '',
  startDate: null,
  startTime: null,
  endDate: null,
  endTime: null,
  hours: 0.0,
  payBonus: 1,
  noCharge: 0,
  description: '',
  techNote: '',
  mileage: 0,
  type: '',
  status: '',
  timecardId: '',
  expenseAmount: 0,
  attFileName: null,
};

export const hourFields = [
  { id: 'workHours', label: 'Worked', shortLabel: 'WRK' },
  { id: 'sickHours', label: 'Sick', shortLabel: 'SCK' },
  { id: 'vacationHours', label: 'Vacation', shortLabel: 'VAC' },
  { id: 'holidayHours', label: 'Holiday', shortLabel: 'HOL' },
];

export const calculatedHourFields = [
  { id: 'clockedHours', label: 'Clocked' },
  { id: 'serviceHours', label: 'Service' },
  { id: 'bonusHours', label: 'Bonused' },
];
